import api from "@/api/api";
import { dictionary } from "@/shared/services/dictionary";
import { isNull } from "@/shared/utils/utils";
import moment from "moment";
import {
  Field,
  Icon,
  CellGroup,
  DatetimePicker,
  Popup,
  Form,
  Uploader,
  Button,
  DropdownMenu,
  DropdownItem,
  Area,
  Dialog,
} from "vant";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Area.name]: Area,
  },
})
export default class EducateResumeEdit extends Vue {
  // 正在提交
  submitting = false;
  openId = "";
  isPool: any = 0; // 人才库进入（1）或招聘进入（0）
  resumeInfo: any = {}; // 简历信息
  educateInfo: any = {};
  resumeId: any = "";
  id: any = "";

  isUnifiedRecruitOptions: any[] = [
    { text: "是", value: "true" },
    { text: "否", value: "false" },
  ];
  // 日期弹窗的值
  dateValues: any = {};
  // 日期弹窗的状态
  dateShowState: any = {};
  // 地址弹窗的状态
  areaShowState: any = {};
  // 地址控件的值
  areaValues: any = {};

  // 学历选项
  educateTypes: any[] = [];
  // 教育阶段
  educateStages: any[] = [];
  // 学习形式
  learnFormOptions: any[] = [];

  areaList: any = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    province_list: {},
    // eslint-disable-next-line @typescript-eslint/camelcase
    city_list: {},
  };

  startTimeMsg = "";
  endTimeMsg = "";
  collegeNameMsg = "";
  specialtyNameMsg = "";
  educateTypeMsg = "";
  learnFormMsg = "";

  created() {
    this.isPool = sessionStorage.getItem("isPool");
    const wechatUser = JSON.parse(sessionStorage.getItem("wechatUser") || "{}");
    this.openId = wechatUser.openid;
    console.log(this.openId);
    this.resumeId = this.$route.query.resumeId || "";
    this.id = this.$route.query.id || "";
    this.initDictionary();
  }

  mounted() {
    if (this.resumeId) {
      this.initResumeInfo();
    }
  }

  // 初始化简历
  initResumeInfo() {
    const resumeApi =
      this.isPool === "1" ? api.getTalentPoolResume : api.getRecruitResume;
    resumeApi({ openId: this.openId, id: this.resumeId }).then((res: any) => {
      this.resumeInfo = res.resumeInfo;
      if (this.id) {
        this.getEditData();
      }
      this.initTimeValues();
    });
  }

  getEditData() {
    const item = this.resumeInfo["educates"].find((item: any) => {
      return item.id === this.id;
    });
    if (item) {
      this.educateInfo = item;
    }
  }

  // 初始化时间控件值
  initTimeValues() {
    if (this.educateInfo.startTime) {
      this.educateInfo.startTime = moment(this.educateInfo.startTime).format(
        "YYYY-MM"
      );
    }
    if (this.educateInfo.endTime) {
      this.educateInfo.endTime = moment(this.educateInfo.endTime).format(
        "YYYY-MM"
      );
    }
  }

  // 初始化字典值
  initDictionary() {
    // 学历选项
    api.getDictionaries([dictionary.educateType]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.educateTypes = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
    // 教育阶段
    api.getDictionaries([dictionary.educateStage]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.educateStages = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
    // 学习形式
    api.getDictionaries([dictionary.learnFormId]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.learnFormOptions = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
  }

  // 日期输入框点击
  timeControlOnClicked(field: string) {
    let date = this.resumeInfo[field];
    if (isNull(date)) {
      date = new Date();
    }
    this.dateValues[field] = new Date(date);
    this.dateShowState[field] = true;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击取消
  timePopupOnCancel(field: string) {
    this.dateShowState[field] = false;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击确认
  timePopupOnConfirm(val: any, field: string) {
    this.educateInfo[field] = moment(val).format("YYYY-MM");
    this.timePopupOnCancel(field);
  }

  onChange(type: any) {
    switch (type) {
      case "startTime":
        if (!this.educateInfo.startTime) {
          this.startTimeMsg = "开始时间为必填项";
        } else {
          this.startTimeMsg = "";
        }
        break;
      case "endTime":
        if (!this.educateInfo.endTime) {
          this.endTimeMsg = "结束时间为必填项";
        } else {
          this.endTimeMsg = "";
        }
        break;
      case "collegeName":
        if (!this.educateInfo.collegeName) {
          this.collegeNameMsg = "学校名称为必填项";
        } else {
          this.collegeNameMsg = "";
        }
        break;
      case "specialtyName":
        if (!this.educateInfo.specialtyName) {
          this.specialtyNameMsg = "专业为必填项";
        } else {
          this.specialtyNameMsg = "";
        }
        break;
      case "learnForm":
        if (!this.educateInfo.learnForm) {
          this.learnFormMsg = "学习形式为必填项";
        } else {
          this.learnFormMsg = "";
        }
        break;
      case "educateType":
        if (!this.educateInfo.educateType) {
          this.educateTypeMsg = "学历为必填项";
        } else {
          this.educateTypeMsg = "";
        }
        break;
    }
  }

  validat(): boolean {
    const validator: any = {
      startTime: {
        name: "开始时间",
      },
      endTime: {
        name: "结束时间",
      },
      collegeName: {
        name: "学校名称",
      },
      specialtyName: {
        name: "专业",
      },
      learnForm: {
        name: "学习形式",
      },
      educateType: {
        name: "学历",
      }
    };
    const keys = Object.keys(validator);
    for (const key of keys) {
      const value = this.educateInfo[key];
      if (isNull(value)) {
        Dialog({ message: validator[key].name + "为必填项" });
        return false;
      }
    }
    return true;
  }

  // 提交
  submit() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    if (!this.validat()) {
      this.submitting = false;
      return;
    }
    if (
      new Date(this.educateInfo.startTime) > new Date(this.educateInfo.endTime)
    ) {
      Dialog.alert({
        title: "错误",
        message: "教育经历的结束时间不能早于开始时间",
      });
      this.submitting = false;
      return;
    }

    if (!this.id) {
      if (!this.resumeInfo["educates"]) {
        this.resumeInfo["educates"] = [];
      }
      this.educateInfo.startTime = moment(this.educateInfo.startTime).format("YYYY-MM-01")
      this.educateInfo.endTime = moment(this.educateInfo.endTime).format("YYYY-MM-01")
      this.resumeInfo["educates"].push(this.educateInfo);
    }
    this.editResumeInfo();
  }

  editResumeInfo() {
    const isPool = sessionStorage.getItem("isPool");
    const editResumeApi =
      isPool === "1" ? api.editTalentPoolResume : api.editRecruitResume;

    const entity = {
      openId: this.openId,
      resumeInfo: this.resumeInfo,
    };
    editResumeApi(entity).then((res) => {
      this.$router.push(`/resume-detail?resumeId=${this.resumeId}`);
    }).finally(() => {
      this.submitting = false;
     });
  }
}
